import { styled } from "@mui/material/styles";
import StayCurrentPortraitIcon from "@mui/icons-material/StayCurrentPortrait";
import StayCurrentLandscapeIcon from "@mui/icons-material/StayCurrentLandscape";
import PropTypes from "prop-types";

import { DeviceType } from "enums/templateGroup";

const StyledChip = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "white",
  height: 22,
  width: 22,
  borderRadius: "50%",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: 4,
  "& svg": {
    color: "white",
    width: 14,
  },
  [theme.breakpoints.up("mobile")]: {
    marginLeft: 6,
  },
}));

const DeviceBadge = ({ type }) => {
  if (!type || !DeviceType[type]) return null;

  return (
    <StyledChip>
      {type === DeviceType.Horizontal ? <StayCurrentLandscapeIcon /> : <StayCurrentPortraitIcon />}
    </StyledChip>
  );
};

DeviceBadge.propTypes = {
  type: PropTypes.oneOf(Object.values(DeviceType)),
};

export default DeviceBadge;
